<script>
import { mapGetters } from 'vuex';
import Checkbox from './Checkbox';
import { Howl } from 'howler';

export default {
  name: 'QuizOption',
  components: {
    Checkbox
  },
  props: {
    id: String,
    option: Object,
  },
  data: () => {
    return {
      isChecked: false,
      sound: null,
    }
  },
  mounted() {
    if (this.option.is_correct) {
      if (this.option.sound) {
        this.sound = new Howl({ 
          src: [this.option.sound], 
          autoplay: true, 
          loop: true 
        });
      }
      this.$store.dispatch('incrementTotalCorrectAnswers');
    }
  },
  methods: {
    onClick() {
      if (!this.isChecked) {
        if (this.sound)
          this.sound.fade(1, 0, 500);
        if (this.option.is_correct)
          this.$store.dispatch('answeredCorrect');
        else
          this.$store.dispatch('answeredWrong');
        this.isChecked = true;
      }
    }
  },
  computed: {
    ...mapGetters({
      playSounnds: 'getGlobalAudioState',
    }),
  },
  watch: {
    playSounnds(newValue, oldValue) {
      if (newValue !== oldValue && this.sound) {
        if (newValue && !this.isChecked)
          this.sound.fade(0, 1, 500);
        else
          this.sound.fade(1, 0, 500);
      }
    },
  },
};
</script>

<template>
  <div class="quiz-option">
      <checkbox 
        class="quiz-option__checkbox" 
        v-bind:isCorrect="option.is_correct" 
        v-bind:label="option.title" 
        v-bind:img="option.img"
        v-on:clicked="onClick()" />
    </div>
</template>

<style scoped lang="scss">
.quiz-option {
  padding: 0;
}
</style>
